import React from 'react';
import { Mail, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-gray-900 text-white pt-16 pb-10 border-t border-gray-800" data-id="element-54">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-55">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16" data-id="element-56">
          <div data-id="element-57">
            <p className="text-lg font-medium max-w-md text-gray-400" data-id="element-58">
              We provide the fastest, fairest way to sell your home. No games,
              no hidden fees, just results.
            </p>
          </div>

          <div data-id="element-59">
            <h3 className="text-lg font-bold uppercase tracking-wider mb-6 text-slate-400" data-id="element-60">
              Contact
            </h3>
            <ul className="space-y-4" data-id="element-61">
              <li className="flex items-center gap-3" data-id="element-62">
                <Phone className="w-5 h-5 text-gray-500" data-id="element-63" />
                <a href="tel:630-686-7233" className="font-medium hover:text-white transition-colors" data-id="element-64">
                  630-686-7233
                </a>
              </li>
              <li className="flex items-center gap-3" data-id="element-65">
                <Mail className="w-5 h-5 text-gray-500" data-id="element-66" />
                <span className="font-medium" data-id="element-67">ravenadvisorsllc@gmail.com</span>
              </li>
            </ul>
          </div>

          <div data-id="element-68">
            <h3 className="text-lg font-bold uppercase tracking-wider mb-6 text-slate-400" data-id="element-69">
              Legal
            </h3>
            <ul className="space-y-4 font-medium text-gray-400" data-id="element-70">
              <li data-id="element-71">
                <Link to="/privacy" className="hover:text-white transition-colors" data-id="element-72">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-73">
                <Link to="/terms" className="hover:text-white transition-colors" data-id="element-74">
                  Terms of Service
                </Link>
              </li>
              <li data-id="element-75">
                <a href="#" className="hover:text-white transition-colors" data-id="element-76">
                  Disclosures
                </a>
              </li>
              <li data-id="element-77">
                <a href="#" className="hover:text-white transition-colors" data-id="element-78">
                  Accessibility
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-79">
          <p className="text-sm text-gray-500 font-medium" data-id="element-80">
            © {new Date().getFullYear()} Raven Advisors. All rights reserved.
          </p>
          <p className="text-sm text-gray-600 font-medium" data-id="element-81">
            Designed for speed. Built for trust.
          </p>
        </div>
      </div>
    </footer>;
}